import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Grid, TextField } from "@material-ui/core";

import ModalSolicitud from "../components/ModalSolicitud";

/**
 * Crear o editar un horario: solo la hora de entrada y la de salida. Al
 * editar, tambien se puede retirar (con confirmacion), que es lo unico que
 * no tiene boton propio en la lista.
 *
 * `onGuardar` y `onRetirar` resuelven true si el backend acepto.
 */
const ModalHorario = ({ horario, onGuardar, onRetirar, onCerrar }) => {
  const [entrada, setEntrada] = useState(horario?.hora_entrada ?? "");
  const [salida, setSalida] = useState(horario?.hora_salida ?? "");
  const [enviando, setEnviando] = useState(false);
  const [confirmando, setConfirmando] = useState(false);

  const ejecutar = async (accion) => {
    setEnviando(true);
    const ok = await accion();
    if (!ok) setEnviando(false);
  };

  const acciones = confirmando ? (
    <>
      <Button disabled={enviando} onClick={() => setConfirmando(false)}>
        No
      </Button>
      <Button color="secondary" disabled={enviando} onClick={() => ejecutar(onRetirar)}>
        Sí, retirar el horario
      </Button>
    </>
  ) : (
    <>
      {horario && (
        <Button color="secondary" disabled={enviando} onClick={() => setConfirmando(true)}>
          Retirar horario
        </Button>
      )}
      <Button
        color="primary"
        disabled={!entrada || !salida || enviando}
        onClick={() => ejecutar(() => onGuardar(entrada, salida))}
      >
        {horario ? "Guardar" : "Crear"}
      </Button>
    </>
  );

  return (
    <ModalSolicitud
      titulo={horario ? "¡ Editar Horario !" : "¡ Nuevo Horario !"}
      ancho="xs"
      onCerrar={onCerrar}
      acciones={acciones}
    >
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            fullWidth
            type="time"
            label="Entrada"
            InputLabelProps={{ shrink: true }}
            value={entrada}
            onChange={({ target }) => setEntrada(target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            type="time"
            label="Salida"
            InputLabelProps={{ shrink: true }}
            value={salida}
            onChange={({ target }) => setSalida(target.value)}
          />
        </Grid>
      </Grid>
    </ModalSolicitud>
  );
};

ModalHorario.propTypes = {
  /** Sin horario, crea uno nuevo. */
  horario: PropTypes.shape({
    hora_entrada: PropTypes.string,
    hora_salida: PropTypes.string,
  }),
  onGuardar: PropTypes.func.isRequired,
  onRetirar: PropTypes.func,
  onCerrar: PropTypes.func.isRequired,
};

ModalHorario.defaultProps = { horario: null, onRetirar: null };

export default ModalHorario;
